import { Component, OnInit } from '@angular/core';
import { AClaveRequest } from '../../_infrastructure/types/aclave';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { catchError, of, tap } from 'rxjs';
import { ComponentBase } from '../../_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
import { ArrobaClaveService } from '../../_infrastructure/classes/services/arroba-clave.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login-clave',
    templateUrl: './login-clave.component.html',
    styleUrls: ['./login-clave.component.scss'],
})
export class LoginClaveComponent extends ComponentBase {
    aClaveRequest = new AClaveRequest();

    constructor(
        private router: Router,
        private arrobaClaveService: ArrobaClaveService,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    /**
     * Este método primero invoca al servicio que devuelve la petición de LOGIN firmada con el certificado,
     * para posteriormente remitirla por POST a Cl@ve.
     * aClaveRequest contiene los datos con los que se rellena el form que se envía a Cl@ve.
     */
    doLoginClave(): void {
        this.arrobaClaveService
            .doInvokeOptions()
            .pipe(
                tap((res: any) => {
                    if (res?.StatusCode === 200) {
                        this.doPostRequestToClave();
                        return;
                    }
                    console.error('KO desde Options.');
                    this.router.navigate(['/error/loginko']);
                }),
                catchError((error: any) => {
                    this.catchServerError(error);
                    console.error('KO desde Options');
                    this.router.navigate(['/error/loginko']);
                    return of(null);
                }),
            )
            .subscribe();
    }

    private doPostRequestToClave(): void {
        this.arrobaClaveService
            .doGetLoginRequest()
            .pipe(
                tap((aClaveRequest: AClaveRequest) => {
                    this.aClaveRequest = aClaveRequest;
                    setTimeout(() => {
                        const form = document.querySelector('#formClaveLogin') as HTMLFormElement;
                        // @author scalero1 - Se hace el POST desde un formulario HTML, porque directamente con http.post
                        // o desde el core, Cl@ve devuelve el error invalid.sp.domain
                        form.submit();
                    }, 0);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    console.error('KO when Posting request to Cl@ve');
                    return of(null);
                }),
            )
            .subscribe();
    }
}
